<template>
<div>
    <bar-manut 
        single-entity="Grupo de Fornecedor" 
        plural-entity="Grupos de Fornecedor" 
        :crud="this.crud" 
        :btn-delete="true"
        @closeform="closeForm" 
        @delete="handleDelete" 
        @save="handleSave">
    </bar-manut>
    <div>
        <div class="default-container">
            <div class="row">
                <form-field v-model="grufor.codgrufor" :metadata="metadata.grufor.codgrufor" type="text" col="2" :disabled="true"></form-field>

                <form-field ref="descricao" v-model="grufor.descricao" type="text" col="6" :metadata="metadata.grufor.descricao" 
                    name="descricao" :v-errors="errors" v-validate="metadata.grufor.descricao.validator"></form-field>
            </div>
        </div>
    </div>
</div>

</template>

<script>

import { SysVars } from '../main'
import { apiORDSpost, apiORDSdelete } from '../shared/api-functions'

export default {
    props: {
        index: '',
        crud: '',
    },

    data() {
        return {
            crudText: '',
            grufor: {...this.$store.getters.getEntities.grufor},
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [],  //armazena as mensagens de validacao do servidor para mostrar em tela
        }
    },

    computed: {
        editing: function () {
            return this.crud == SysVars.crudU
        }

    },

    methods: {
        closeForm () {
            this.$emit('closeform', this.grufor.codgrufor)
        },

        handleSave () {
            //BOTAO SALVAR
            this.$validator.validateAll().then(isValid => {
                if (!isValid) {
                    this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
                } else {
                    this.apiPost()
                }
            })
        },

        handleDelete () {
            //BOTAO Excluir
            this.apiDelete()
        },

        async loadData () {
            //carrega o registro para alteracao ou visualizacao
            await this.$store.dispatch('loadGrufor', { id: this.index } )                        
            if (this.$store.getters.getGrufor) {
                this.grufor = {...this.$store.getters.getGrufor}                
            }  
            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip()
            })
            
        },

        async apiDelete () {
            //efetua a exclusao
            var modulo = 'cg/grufor/' + this.grufor.codgrufor

            const data = await apiORDSdelete(this.$store, modulo)
            this.$erpToastDeleted()
            this.closeForm()
        },

        async apiPost () {
            //efetua a gravacao

            var modulo = 'cg/grufor/'
            var sendData = {}

            sendData = { grufor: this.grufor }

            let metodo = 'post'
            let update = false
            if (this.crud != SysVars.crudI) {
                metodo = 'put'
                update = true
            }

            const data = await apiORDSpost(this.$store, modulo, sendData, metodo)
            if (data.errmessages) {
              this.errmessages = data.errmessages
              this.$erpToastError('Alguns erros precisam ser corrigidos.')
            } else {
                if (update) {
                    this.$erpToastUpdated()
                } else {
                    this.$erpToastInserted()
                }
                this.errmessages = {}
                this.closeForm()
            }
        },
        
    },

    components: {

    },

    beforeCreate () {

    },

    created () {
        
        this.crudText = this.$crudText(this.crud)

        if (this.crud == SysVars.crudI) {
        } else {
            this.loadData()  
        }
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip()
            this.$refs.descricao.focus()
        })        
    }

}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/forms/grufor-form.vue